const getters = {
  user: state=>state.user,
  count: state=>state.user.count,
  age: state=>state.user.age,
  sex: state=>state.user.sex,
  name: state=>state.user.name
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js